/**
 * The reply text in a card above the action bar, once a draft exists: the subject, the
 * body with the gaps to fill marked, and the "Copied" status (`ReplyText`). On the page
 * the bar is pinned to the viewport bottom, so the text sits above it in the flow and a
 * sales person reads what "Copy the reply" copies before pressing it. Nothing is sent.
 */

import { Card } from "@norican/react";

import { ReplyText, type ReplyTextProps } from "@/features/case-review/reply-text";

export function ReplyCard(props: ReplyTextProps) {
  return (
    <Card variant="outline" className="min-w-0" data-reply-card>
      <Card.Body padding="sm">
        <ReplyText {...props} />
      </Card.Body>
    </Card>
  );
}
